$(".collection-slider").slick({
  dots: false,
  infinite: true,
  arrow: true,
  speed: 300,
  autoplay: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "150px",

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: false,
        dots: false,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
$(".brands-slider").slick({
  dots: true,
  infinite: true,
  arrow: false,
  speed: 300,
  autoplay: true,
  slidesToShow: 7,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        arrow: false,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        arrow: false,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".featured-product-slider").slick({
  dots: true,
  infinite: true,
  arrow: false,
  speed: 300,
  autoplay: true,
  slidesToShow: 4,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrow: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".feat-slider-wrapper").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  fade: true,
});

// Render hotspots for each slide

// If additional behavior for hotspots is needed, you can target them here
// $('.hotspot').on('mouseenter', function () {
//   $(this).find('.hotspot-label').fadeIn(200);
// }).on('mouseleave', function () {
//   $(this).find('.hotspot-label').fadeOut(200);
// });
$(".feat-slider-wrapper.text-slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  autoplay: true,
});

// Product page media gallery css
// Initialize the main product gallery
$(".cust-product-gallery").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: false, // Show arrows
  fade: true, // Fade effect
  asNavFor: ".cust-product-thumbs", // Sync with thumbnails
});

// Initialize the thumbnail navigation
$(".cust-product-thumbs").slick({
  slidesToShow: 4, // Show 4 thumbnails
  slidesToScroll: 1,
  arrows: false,
  asNavFor: ".cust-product-gallery", // Sync with main gallery
  dots: false, // No dots for thumbnails
  centerMode: false, // Center thumbnails
  focusOnSelect: true, // Allow thumbnail click to navigate
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
$(".custloginSlider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
});



// ----------------------------------------------------------
$(".toggle-description-btn").click(function () {
  const hiddenContent = $(this).siblings("p").find(".hidden-content");
  if (hiddenContent.is(":visible")) {
    hiddenContent.slideUp(); // Hide the extra content
    $(this).text("Show More"); // Update button text
  } else {
    hiddenContent.slideDown(); // Show the extra content
    $(this).text("Show Less"); // Update button text
  }
});

$(".toggle-description").on("click", function (event) {
  event.preventDefault();
  var target = $("#accordion-container");
  if (target.length) {
    event.preventDefault();
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: target.offset().top - 150,
        },
        3000
      ); // Adjust the duration as needed
  }
});


// Brands page smooth scroll
$(".vendor-index a, .product-short-description a").on("click", function (e) {
  e.preventDefault(); // Prevent the default anchor behavior
  const targetId = $(this).attr("href").substring(1); // Get the target ID
  const targetElement = $("#" + targetId); // Get the target element

  if (targetElement.length) {
    $("html, body").animate(
      {
        scrollTop: targetElement.offset().top - 150,
      },
      2000
    ); // Scroll with smooth animation (1000ms duration)
  }
});

$(".activate_btn").on("click", function () {
  $(".account-activation-container").show();
  $(".login__form, .cust-activate-account").hide();
});

$(".back-btn").on("click", function () {
  $(".login__form, .cust-activate-account").show();
  $(".account-activation-container").hide();
});

$(".login__forgot-password a").on("click", function () {
  $(".login__form, .cust-activate-account").hide();
  $(".login-inner").addClass("recover-activate");
   $(".recover-password").show();
});


$(".forget-cancel-btn").on("click", function () {
  $(".login__form, .cust-activate-account").show();
  $(".login-inner").removeClass("recover-activate");
  if (window.location.hash === "#recover") {
    history.replaceState(null, null, window.location.pathname);
  }
  $(".recover-password").hide();
});
if (window.location.hash === "#recover") {
  $(".login__form, .cust-activate-account").hide();
  $(".login-inner").addClass("recover-activate");
   $(".recover-password").show();
}


// document.addEventListener("DOMContentLoaded", function () { 
//     document.body.addEventListener("click", function (event) {
//         if (event.target.closest("#gf-grid .pagination a")) { 
//           // console.log('clicked pagination')
//             setTimeout(function () {
//                 window.scrollTo({
//                     top: 0,
//                     behavior: "smooth"
//                 });
//             }, 320); 
//         }
//     });
// });


// CUSTOM WISHLIST FUNCTIONALITY
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".wishlist-btn").forEach(button => {
    button.addEventListener("click", async function () {
      const productId = this.dataset.productId;
      const customerId = this.dataset.customerId;
      const isRemoving = this.classList.contains("remove");
      const url = isRemoving ? "/wishlist/remove" : "/wishlist/add";

      // Add loading effect
      this.classList.add("loading");

      try {
        const response = await fetch("https://wishlist-app-arjen-f8e5b84055d3.herokuapp.com" + url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ customer_id: customerId, product_id: productId, shop: "3f9b62-6d.myshopify.com" })
        });
        console.log(JSON.stringify({customer_id: customerId, product_id: productId}));

        const data = await response.json();
        if (data.success) {
          // Toggle button UI
          this.innerHTML = isRemoving
            ? '<svg width="800px" height="800px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.24264 8.24264L8 15L14.7574 8.24264C15.553 7.44699 16 6.36786 16 5.24264V5.05234C16 2.8143 14.1857 1 11.9477 1C10.7166 1 9.55233 1.55959 8.78331 2.52086L8 3.5L7.21669 2.52086C6.44767 1.55959 5.28338 1 4.05234 1C1.8143 1 0 2.8143 0 5.05234V5.24264C0 6.36786 0.44699 7.44699 1.24264 8.24264Z" fill="#ffffff"/> </svg>'
            : '<svg width="800px" height="800px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.24264 8.24264L8 15L14.7574 8.24264C15.553 7.44699 16 6.36786 16 5.24264V5.05234C16 2.8143 14.1857 1 11.9477 1C10.7166 1 9.55233 1.55959 8.78331 2.52086L8 3.5L7.21669 2.52086C6.44767 1.55959 5.28338 1 4.05234 1C1.8143 1 0 2.8143 0 5.05234V5.24264C0 6.36786 0.44699 7.44699 1.24264 8.24264Z" fill="#557058"/> <svg>';
          this.classList.toggle("remove");
          this.classList.toggle("add");
        } else {
          alert("Error: " + data.error);
        }
      } catch (error) {
        alert("Something went wrong. Please try again.");
      } finally {
        // Remove loading effect
        this.classList.remove("loading");
      }
    });
  });
});